import axiosInstance from '@/utils/api.js'

var state = {
  captivePortal: []
}

var getters = {
  CAPTIVE_PORTAL: (state) => {
    return state.captivePortal
  }
}

var mutations = {
  SET_CAPTIVE_PORTAL: (state, payload) => {
    state.captivePortal = payload
  }
}

var actions = {
  GET_CAPTIVE_PORTAL: async (context, payload) => {
    let result = await axiosInstance.get('/settings/captive_portal_udata_list')
    if (result.status === 200) {
      context.commit('SET_CAPTIVE_PORTAL', result.data)
    }
  },
  CREATE_CAPTIVE_PORTAL: (context, payload) => {
    return axiosInstance.post('/settings/captive_portal_udata', payload)
  },
  UPDATE_CAPTIVE_PORTAL: (context, payload) => {
    return axiosInstance.put('/settings/captive_portal_udata', payload)
  },
  DELETE_CAPTIVE_PORTAL: (context, payload) => {
    return axiosInstance.delete('/settings/captive_portal_udata?cp_utariff_data_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/captivePortal.js